export const weekday = {
    sunday: 0,
    monday: 1,
    tuesday: 2,
    wednesday: 3,
    thursday: 4,
    friday: 5,
    saturday: 6
} as const;

export type WeekdayKey = keyof typeof weekday;

export type WeekdayValue = typeof weekday[WeekdayKey];

export type WeekdayName = 
| 'Monday'
| 'Tuesday'
| 'Wednesday'
| 'Thursday'
| 'Friday'
| 'Saturday'
| 'Sunday';

export const weekdayName: Record<WeekdayKey, WeekdayName> = {
    monday: 'Monday',
    tuesday: 'Tuesday',
    wednesday: 'Wednesday',
    thursday: 'Thursday',
    friday: 'Friday',
    saturday: 'Saturday',
    sunday: 'Sunday'
} as const;

export const weekdayKeys: Readonly<WeekdayKey[]> = [
    'monday',
    'tuesday',
    'wednesday',
    'thursday',
    'friday',
    'saturday',
    'sunday'
];

export const weekdayAbbreviation = {
    [weekday.monday]: 'Mon',
    [weekday.tuesday]: 'Tue',
    [weekday.wednesday]: 'Wed',
    [weekday.thursday]: 'Thu',
    [weekday.friday]: 'Fri',
    [weekday.saturday]: 'Sat',
    [weekday.sunday]: 'Sun'
} as const;

/**
 * Maps weekday for week, that starts from Sunday
 * to weekday for week, that starts from Monday.
 */
export const weekdayByIndexMap: Record<number, WeekdayValue> = {
    0: weekday.monday,
    1: weekday.tuesday,
    2: weekday.wednesday,
    3: weekday.thursday,
    4: weekday.friday,
    5: weekday.saturday,
    6: weekday.sunday
} as const;

export type WeekdayIndex = keyof typeof weekdayByIndexMap;

/**
 * Maps weekday for week, that starts from Monday
 * to weekday for week, that starts from Sunday.
 */
export const indexByWeekdayMap: Record<WeekdayValue, WeekdayIndex> = {
    [weekday.monday]: 0,
    [weekday.tuesday]: 1,
    [weekday.wednesday]: 2,
    [weekday.thursday]: 3,
    [weekday.friday]: 4,
    [weekday.saturday]: 5,
    [weekday.sunday]: 6
};

export type WeekdayAbbreviation = typeof weekdayAbbreviation[WeekdayValue];

export const weekdayAbbreviationList: WeekdayAbbreviation[] = [ 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun' ];

export const weekdayList = Object.values(weekdayName);
